import {
  faFileArrowUp,
  faFilePen,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React from "react";

import TemplateFormButton from "../common/TemplateFormButton";

const ChooseTemplateConstruction = ({
  setShowResetTemplateConstructionModal,
  openConfirmationOpenIfFieldsFilled,
  isAnyTemplateContentFilled,
  onSelect,
  selectedChoice,
  handleHighlightClick,
  setShowConfirmTemplateConstructionModal,
  disableButton,
}) => {
  const handlePDFUploadSelection = (e) => {
    handleHighlightClick();

    // If the user has already selected the upload option, don't open the file uploader
    if (selectedChoice === "upload") {
      return;
    }
    handleButtonSelection(e, "upload");
  };

  const handleButtonSelection = (e, value) => {
    const modalOpened = openConfirmationOpenIfFieldsFilled(
      setShowConfirmTemplateConstructionModal,
    );
    if (!modalOpened) {
      onSelect(value);
    }
  };
  return (
    <div className="mb-4">
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">
        Template Construction
        <Tooltip
          arrow
          placement="right"
          title="Reset Template Construction. This will clear any information you've entered."
        >
          <span>
            <FontAwesomeIcon
              icon={faRotateLeft}
              size="lg"
              className={"ml-2 text-indigo-500 cursor-pointer"}
              onClick={() => {
                setShowResetTemplateConstructionModal(true);
              }}
            />
          </span>
        </Tooltip>
      </label>
      {(!isAnyTemplateContentFilled || selectedChoice) && (
        <div className="flex gap-2">
          <TemplateFormButton
            icon={faFileArrowUp}
            title={
              <span className="flex flex-row items-center">
                Automatic{" "}
                <FontAwesomeIcon
                  icon={faSparkles}
                  className="text-yellow-400 ml-1"
                />
              </span>
            }
            description="Upload a PDF of your existing template and we'll automatically detect its contents."
            isSelected={selectedChoice === "upload"}
            name="constructionChoice"
            value="upload"
            checked={selectedChoice === "upload"}
            onChange={(e) => handleButtonSelection(e, "upload")}
            onClick={(e) => handlePDFUploadSelection(e)}
            disableButton={disableButton}
          />
          <TemplateFormButton
            icon={faFilePen}
            title="From Scratch"
            description="Copy and paste your existing template fields or type them out from scratch."
            isSelected={selectedChoice === "scratch"}
            name="constructionChoice"
            value="scratch"
            checked={selectedChoice === "scratch"}
            onChange={(e) => handleButtonSelection(e, "scratch")}
            disableButton={disableButton}
          />
        </div>
      )}
    </div>
  );
};
export default ChooseTemplateConstruction;
